import React from "react";
import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";

/**
 * Nette placeholder voor [NOG AANVULLEN]-plekken uit de brontekst.
 * Zichtbaar maar subtiel — niet als "kapot" ogen.
 * Toont "Info volgt" / "Folgt in Kürze" / "Coming soon" o.b.v. taal
 * wanneer geen children worden meegegeven.
 */
export const PlaceholderNote = ({ children }) => {
  const { t } = useTranslation();
  const label = children || t("common.info_volgt");
  return (
    <span
      data-testid="placeholder-note"
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#F4F8FB] border border-dashed border-[#6BC0E8] text-[#5A7594] text-[11px] font-[Poppins] font-medium"
    >
      <Info className="w-3 h-3" />
      {label}
    </span>
  );
};

export default PlaceholderNote;
